import React  from 'react';
import './index.scss';
import { Icon, IconGroup, Segment } from 'semantic-ui-react';
import { InfoMessage, ClippedContent } from "dyl-components";

const DialerHeader = ({ state = 'idle', phoneErrors, campaignName, isDialPadActive, onToggleDialpad }) => {
    return (
        <>
            <Segment className={`DialerHeader ${state ? `DialerHeader--${state}` : ""}`}>
                <div className="DialerHeader__content">
                    <Icon className={`fa-solid fa-megaphone DialerHeader__icon`} />
                    <div className="DialerHeader__displayed-name">
                        <ClippedContent>
                            {campaignName}
                        </ClippedContent>
                    </div>
                    {isDialPadActive ? (
                        <IconGroup className="DialerHeader__dialpad-icon" onClick={onToggleDialpad} link={Boolean(onToggleDialpad)}>
                            <Icon size='big' className="fas fa-square" inverted />
                            <Icon className={`fas fa-dialpad`} />
                        </IconGroup>
                    ) : (
                        <Icon className={`fas fa-dialpad DialerHeader__dialpad-icon`} inverted onClick={onToggleDialpad} link={Boolean(onToggleDialpad)} />
                    )}
                </div>
                {phoneErrors && <InfoMessage content={phoneErrors} type='error' />}
            </Segment>
        </>
    )
};

export default DialerHeader;
